import type { Example } from '../types';

export const lightingSystemExample: Example = {
  id: 'lighting-system',
  title: 'Lighting System',
  categoryId: 'viewer',
  description: 'All 4 light types: ambient, directional, point, spot',
  scadCode: `/* Lighting System */

// markdown:tip
// **Lighting System** — Meshpit exposes all four Three.js light types from
// SCAD code. Toggle each light on/off and tune its intensity to see how
// they contribute individually. \`scene_default_lights()\` scales the
// built-in three-point rig.

/* [Built-in Rig] */

// Scale the built-in rig (key/fill/rim)
use_default_rig = true;

// Ambient intensity
rig_ambient = 0.4; // [0:0.05:2.0] {use_default_rig == true}

// Key intensity
rig_key = 1.2; // [0:0.05:3.0] {use_default_rig == true}

// Fill intensity
rig_fill = 0.35; // [0:0.05:1.5] {use_default_rig == true}

/* [Extra Lights] */

// Add ambient light?
add_ambient = false;

// Ambient intensity
ambient_intensity = 0.5; // [0:0.05:2.0] {add_ambient == true}

// Add point light?
add_point = true;

// Point color
// color
point_color = [1.0, 0.6, 0.2];

// Point intensity
point_intensity = 1.5; // [0:0.1:5.0] {add_point == true}

// Point distance
point_distance = 120; // [20:5:300] {add_point == true}

// Add spot light?
add_spot = true;

// Spot color
// color
spot_color = [0.5, 0.7, 1.0];

// Spot angle (degrees)
spot_angle = 35; // [5:1:80] {add_spot == true}

// Spot penumbra
spot_penumbra = 0.3; // [0:0.05:1.0] {add_spot == true}

// --- parameters end ---

$fn = 48;

// Scene lights
if (use_default_rig)
  scene_default_lights(ambient=rig_ambient, key=rig_key, fill=rig_fill, rim=0.15);

if (add_ambient)
  light_ambient(color=[1,1,1], intensity=ambient_intensity);

if (add_point)
  light_point(
    color=point_color,
    position=[40, -30, 60],
    intensity=point_intensity,
    distance=point_distance
  );

if (add_spot)
  light_spot(
    color=spot_color,
    position=[-50, 40, 90],
    intensity=2.0,
    distance=200,
    angle=spot_angle,
    penumbra=spot_penumbra
  );

// Geometry — a cluster of shapes to show off the lighting
color([0.75, 0.72, 0.7])
material(material_def(metalness=0.05, roughness=0.35)) {
  // Central sphere
  sphere(r=18);
  // Left cube
  translate([-38, 0, 0]) cube([20, 20, 20], center=true);
  // Right cylinder
  translate([38, 0, 0]) cylinder(d=18, h=28, center=true);
  // Back cone
  translate([0, 36, 0]) cylinder(d1=20, d2=0, h=28, center=true);
}

// Ground plane
color([0.18, 0.18, 0.2])
material(material_def(roughness=0.9))
translate([0, 0, -19])
  cube([120, 120, 2], center=true);
`,
};
